import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { LoginContext } from '../../../context/LoginContext';
import { useNavigate } from 'react-router-dom';
import { PREMIUM_PLANS, planFeatures } from '../../../utils/premiumPlans';

const PhonePePayment = () => {
  const [loadingPlan, setLoadingPlan] = useState(null);
  const navigate = useNavigate();
  const { isLoggedIn, userId, userName, userData } = useContext(LoginContext);


  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, []);


  const handlePayment = async (plan) => {
    setLoadingPlan(plan.code);
    try {
      const orderId = `order_${Date.now()}`;

      // Price and validity are resolved server-side from plan_code
      const response = await axios.post(process.env.REACT_APP_API_PAYMENT_URL + 'phonepe/initiate', {
        order_id: orderId,
        plan_code: plan.code,
        user_id: userId,
        name: userName || userData?.name || 'Member',
        email: userData?.email || '',
        gender: userData?.gender || '',
        callbackUrl: process.env.REACT_APP_API_PAYMENT_CALLBACK_URL
      });

      if (response.data && response.data.redirectUrl) {
        // Redirect user to PhonePe payment page
        window.location.href = response.data.redirectUrl;
      } else {
        alert('Failed to get payment URL');
      }
    } catch (error) {
      console.error('Payment initiation error:', error);
      alert('Payment initiation failed.');
    } finally {
      setLoadingPlan(null);
    }
  };

  return (
    <div>

      <div className='container'>
        <div className="row justify-content-center">

          {PREMIUM_PLANS.map((plan) => (
            <div className="col-md-4 my-3" key={plan.code}>
              <div className="card mx-auto pricing-card shadow-sm p-3 h-100">
                <div className="card-body d-flex " style={{ flexDirection: "column" }}>
                  <span
                    className="badge bg-warning text-dark mb-2 mx-auto"
                    style={{ visibility: plan.popular ? 'visible' : 'hidden' }}
                  >
                    Most Popular Plan
                  </span>
                  <h5 className="card-title text-center">Premium</h5>
                  <p className="card-subtitle mb-2 text-muted text-center" style={{ color: "#A16304" }}>India's Trusted Matrimony Services</p>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>
                          <p className='fw-bold mb-0 fs-4 p-0 text-center'>
                            <span className="fw-bold fs-4">₹ {plan.price} </span>/- {plan.validity}
                          </p>
                          <ul className="list-unstyled text-start mt-0">
                            {planFeatures(plan).map((feature) => (
                              <li className="feature p-1" key={feature}><i className="text-success me-2 ">✔</i>{feature}</li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <button
                    className="btn btn-danger w-100 mb-3 mt-auto"
                    onClick={() => handlePayment(plan)}
                    disabled={loadingPlan !== null}
                  >
                    {loadingPlan === plan.code ? 'Upgrading...' : 'Upgrade Plan'}
                  </button>

                </div>
              </div>
            </div>
          ))}

        </div>
      </div>


    </div>
  );
};

export default PhonePePayment;
